import { render } from "./UserRules.vue?vue&type=template&id=34a4591a&scoped=true"
import script from "./UserRules.vue?vue&type=script&lang=js"
export * from "./UserRules.vue?vue&type=script&lang=js"

import "./UserRules.vue?vue&type=style&index=0&id=34a4591a&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a4591a"]])

export default __exports__